import ChannelStatusPage from "@/components/channels/ChannelStatusPage";
import { syncDeck } from "./syncExplainer";

/** Help Genie Sync channel page — product intro and SSO handoff into Sync. */
const SyncChannelPage = () => <ChannelStatusPage appId="sync" deck={syncDeck} />;

export default SyncChannelPage;
